import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientProfile from "./pages/ClientProfile";
import ClientForm from "./pages/ClientForm";
import Login from "./pages/Login";
import Statistici from "./pages/Statistici";
import Stocuri from "./pages/Stocuri";
import UserProfile from "./pages/UserProfile";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import useNetworkStatus from "./hooks/useNetworkStatus";

const AppRoutes = () => {
  const { user, loading } = useContext(AuthContext);
  const { isOnline, connectionType } = useNetworkStatus();

  const showLoadingScreen = loading || !isOnline;

  if (showLoadingScreen) {
    let statusMessage = "Se încarca datele...";
    if (!isOnline) {
      statusMessage = "⛔ Esti offline. Asteapta reconectarea...";
    } else if (["2g", "slow-2g"].includes(connectionType)) {
      statusMessage = "⚠️ Conexiune slaba. Se încarca datele...";
    }
  
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-secondary mb-3" role="status">
            <span className="visually-hidden">Incarcare...</span>
          </div>
          <p>{statusMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
      
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<ClientProfile />} />
        <Route path="/clients/add" element={<ClientForm />} />
        <Route path="/clients/edit/:id" element={<ClientForm />} />

        <Route path="/statistici" element={<Statistici />} />
        <Route path="/stocuri" element={<Stocuri />} />
        <Route path="/user/:id" element={<UserProfile />} />
      </Route>

      {/* 🔹 Dacă ruta nu există, rămâne pe pagina curentă dacă e logat sau merge la login */}
      <Route path="*" element={user ? <Navigate to={window.location.pathname} /> : <Navigate to="/login" />} />
      
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="container mt-4">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;